import { aiproUser, subscriptionType } from '~/helpers/store';

export const isPro = () => {
    const subState = subscriptionType((state) => state);
    const subscription = subState.type ? subState.type.toLowerCase() : "";
    if(!subscription || subscription === 'basic') return false;
    return true;
};

export const isProMax = () => {
    const subState = subscriptionType((state) => state);
    const subscription = subState.type ? subState.type.toLowerCase() : "";
    if(subscription.includes("max")) return true;
    return false;
};

export const isBasic = () => {
    return hasSubscription();
};

export const hasSubscription = () => {
    const subState = subscriptionType((state) => state);
    const subscription = subState.type ? subState.type.toLowerCase() : "";
    if(subscription) return true;
    return false;
}